// extracted by mini-css-extract-plugin
module.exports = {"content":"content--dV0szMFW","label":"label--yjzzhvgM"};